export interface ITeamCardsContent {
	id: number;
	avatarImg: string;
	name: string;
	profession?: string
	linkedIn?: string
	summary?: string
	git?: string

}

export interface ITeamCards {
	id: number,
	titleTeam: string,
	description: string,
	work: string,
	video: string,
	linkCode: string,
	linkLivePage: string,
	taemList: ITeamCardsContent[]
}


export const teamCards: ITeamCards[] = [
	// команда 1
	{
		id: 1,
		titleTeam: '= PixelSquad =',
		description: `Назва проекту: "Авантюра з Ріком і Морті"

Опис завдання:
Вам потрібно розробити інтерактивну сторінку, 
на якій користувачі можуть вирушити у авантюру з Ріком і Морті.

Верстка (дизайн):
Використовуйте колірну палітру з мультсеріалу 
"Рік і Морті".
Використовуйте шрифти, які нагадують шрифти з титрів 
мультсеріалу.
Розробіть інтерфейс, який нагадує екран телепортації, як 
в серіалі.

Робота з API:
Додаток повинен використовувати безкоштовне API, щоб 
отримувати дані про персонажів, локації та епізоди з 
мультсеріалу "Рік і Морті". Наприклад - 
(https://rickandmortyapi.com/)

JS логіка (функціональність):
Розробіть функцію, яка генерує випадкового персонажа та 
відображає інформацію про нього на сторінці. Користувачі 
повинні мати можливість оновлювати інформацію, щоб отримати 
нового персонажа.
Розробіть функцію, яка генерує випадкову локацію з мультсеріалу 
та відображає інформацію про неї на сторінці.
Розробіть функцію, яка генерує випадковий епізод з мультсеріалу 
та відображає інформацію про нього на сторінці.
Розробіть функцію, яка рахує, скільки персонажів, локацій та 
епізодів було отримано користувачем.
Розробіть функціональність, яка дозволяє користувачу додавати 
персонажів, локації та епізоди в обране.
Кнопка «Телепортуватися». При натисканні на неї повинна 
відбуватися зміна локації та персонажів.

Інтерактивність:
При натисканні на кнопку "Телепортуватися", на екрані повинні 
з'являтися анімовані кільця, як у мультсеріалі, та звук 
телепортації.
При наведенні на елементи сторінки, повинні відбуватися зміни 
кольору або анімації, наприклад, при наведенні на кнопку 
"Додати до обраного", кнопка повинна починати блимати.
Розробіть функціональність, яка змінює кольори або розміри 
елементів сторінки при взаємодії користувача. 
(симуляція подорожі між світами)

Технічні вимоги:
Використовуйте HTML, CSS та JavaScript (ReactJs, Vue, Angular) 
для розробки сторінки.
Використовуйте безкоштовний API для отримання даних про 
персонажів, локації та епізоди.
Використовуйте Git для контролю версій.

Максимально використовуйте креатив. Змінюйте всесвіт 
Ріка і Морті за своїм бажанням!
Успіхів у розробці!
`,
		work: `
Провели зустріч, обрали тім ліда і назву команди,
визначились зі стеком, стилізацією і розбили все на мікро 
задачі для виконання, і занесли у дошку Trello,
розробили план-карту сайту, сьогодні засетапим репо і
будемо починати кодити компоненти.

17.05.2023
1) Провели зустріч.
2) Розробили маршрутизацію, api, store.
3) Написали частину стилів - 40% від загального проекту, 
працюємо над адаптивом.
4) Розробили функції для рандомного вибору персонажу, 
локації та епізоду.

23.05.2023
1) Розробляємо сторінку бібліотеки, де користувач зможе 
перегляти, те що було додано в улюблене і статистику: 
скільки рандомних персонажів, епізодів, локацій було 
отримано. 
2) Написали частину стилів: готовність 70% від 
загального проекту, працюємо над адаптивом.
3) Розробляємо "телепорт".`,
		// video: './img/cardImage/screamintothevoid.com_.png',
		video: 'https://www.youtube.com/embed/W_OoDXSRTMs',
		linkCode: 'https://github.com/mariia-kovalova/rick-and-morty-app',
		linkLivePage: 'https://mariia-kovalova.github.io/rick-and-morty-app/',
		taemList:
			[{
				id: 1,
				avatarImg: "/img/event2/maria.jpg",
				name: "Mariia Kovalova",
				profession: "Frontend Developer",
				summary: "https://drive.google.com/file/d/1XeNiX8FC3Q2XWrdJgCJWmnVfIFFSxfg7/view?usp=sharing",
				linkedIn: "https://www.linkedin.com/in/Mariia-Kova-lova/",
				git: "https://github.com/mariia-kovalova",

			},
			{
				id: 2,
				avatarImg: "img/event2/antonV.jpg",
				name: "Anton Vakulych",
				profession: "Front-end developer React",
				summary: "https://drive.google.com/file/d/1fU5OuJ-58rMlVvU_9uXrg6DR5KKeJGgv/view?usp=share_link",
				linkedIn: "https://www.linkedin.com/in/%D0%B0%D0%BD%D1%82%D0%BE%D0%BD-%D0%B2%D0%B0%D0%BA%D1%83%D0%BB%D0%B8%D1%87-119b99225/",
				git: "https://github.com/AntonVak",

			},
			{
				id: 3,
				avatarImg: "https://media.licdn.com/dms/image/D4E03AQEI8J0OLMTyYA/profile-displayphoto-shrink_800_800/0/1681202602047?e=1689206400&v=beta&t=LpDhvWplV1nPLJTs7I5GBqSYRuoy9agMzE2eoPxKGl4",
				name: "Svitlana Honchar",
				profession: "Frontend Developer JavaScript | React",
				summary: "https://www.linkedin.com/in/svitlana-honchar/overlay/1635525929276/single-media-viewer/?profileId=ACoAAEAtK2EBxCGe1JDuvR6Bxfud03FI05k6nNU",
				linkedIn: "https://www.linkedin.com/in/svitlana-honchar/",
				git: "https://github.com/SvitlanaHonchar",

			},

			]
	},
	// команда 2
	{
		id: 2,
		titleTeam: 'DAO',
		description: `Назва проекту: "Авантюра з Ріком і Морті"

Опис завдання:
Вам потрібно розробити інтерактивну сторінку, 
на якій користувачі можуть вирушити у авантюру з Ріком і Морті.

Верстка (дизайн):
Використовуйте колірну палітру з мультсеріалу 
"Рік і Морті".
Використовуйте шрифти, які нагадують шрифти з титрів 
мультсеріалу.
Розробіть інтерфейс, який нагадує екран телепортації, як 
в серіалі.

Робота з API:
Додаток повинен використовувати безкоштовне API, щоб 
отримувати дані про персонажів, локації та епізоди з 
мультсеріалу "Рік і Морті". Наприклад - 
(https://rickandmortyapi.com/)

JS логіка (функціональність):
Розробіть функцію, яка генерує випадкового персонажа та 
відображає інформацію про нього на сторінці. Користувачі 
повинні мати можливість оновлювати інформацію, щоб отримати 
нового персонажа.
Розробіть функцію, яка генерує випадкову локацію з мультсеріалу 
та відображає інформацію про неї на сторінці.
Розробіть функцію, яка генерує випадковий епізод з мультсеріалу 
та відображає інформацію про нього на сторінці.
Розробіть функцію, яка рахує, скільки персонажів, локацій та 
епізодів було отримано користувачем.
Розробіть функціональність, яка дозволяє користувачу додавати 
персонажів, локації та епізоди в обране.
Кнопка «Телепортуватися». При натисканні на неї повинна 
відбуватися зміна локації та персонажів.

Інтерактивність:
При натисканні на кнопку "Телепортуватися", на екрані повинні 
з'являтися анімовані кільця, як у мультсеріалі, та звук 
телепортації.
При наведенні на елементи сторінки, повинні відбуватися зміни 
кольору або анімації, наприклад, при наведенні на кнопку 
"Додати до обраного", кнопка повинна починати блимати.
Розробіть функціональність, яка змінює кольори або розміри 
елементів сторінки при взаємодії користувача. 
(симуляція подорожі між світами)

Технічні вимоги:
Використовуйте HTML, CSS та JavaScript (ReactJs, Vue, Angular) 
для розробки сторінки.
Використовуйте безкоштовний API для отримання даних про 
персонажів, локації та епізоди.
Використовуйте Git для контролю версій.

Максимально використовуйте креатив. Змінюйте всесвіт 
Ріка і Морті за своїм бажанням!

Успіхів у розробці!`,
		work: `
17.05.2023
1.Створили репозіторій;
2.Робимо на 16 Ангулярі;
3.Знайшли безкоштовний макет;
4.Зробили скелетон проекту;
5.Зараз робиться верстка та розбираємося з апі;

23.05.2023
Зроблено 50% проєкту!`,
		// video: './img/cardImage/screamintothevoid.com_.png',
		video: 'https://www.youtube.com/embed/YgtIGA12Frg',
		linkCode: 'https://github.com/waridesu/rick-and-morty',
		linkLivePage: 'https://waridesu.github.io/rick-and-morty/#/',
		taemList:
			[{
				id: 1,
				avatarImg: `img/event2/denis.jpeg`,
				name: `Denis Kononuchenko`,
				profession: `Middle Fronted Developer`,
				summary: `https://www.linkedin.com/in/denis-kononuchenko/`,
				linkedIn: `https://www.linkedin.com/in/denis-kononuchenko/`,
				git: `https://github.com/waridesu`,
			},
			{
				id: 2,
				avatarImg: "img/event2/Olha.jpg",
				name: "Olha Chuchdiuk",
				profession: "Junior FullStack Developer",
				summary: "https://drive.google.com/file/d/1R58oYEZ8Sm1G-wE54hRe1RS303xELwOt/view?usp=sharing",
				linkedIn: "linkedin.com/in/olha-chuzhdiuk-66045a236",
				git: "github.com/OliaChuzhdiuk ",

			},
			{
				id: 3,
				avatarImg: "img/event2/antonina.jpg",
				name: "Antonina Honcharenko",
				profession: "Frontend Developer",
				summary: "https://drive.google.com/file/d/1ySR1UV1LZSSXQYb7FvCYhT9qhDXxNXiU/view?usp=sharing",
				linkedIn: "https://www.linkedin.com/in/antonina-honcharenko/",
				git: "https://github.com/AntoninaHoncharenko",


			}
			]
	},
	// команда 3
	{
		id: 3,
		titleTeam: `The King's Hand`,
		description: `Тема: Гра Престолів

Опис:
Ваше завдання - створити веб-додаток, який використовує дані з 
серіалу "Гра престолів", щоб визначити наступного короля 
Семи Королівств. Користувач повинен мати можливість вибрати 
персонажа зі списку, а додаток повинен, в залежності від його 
характеристик, розрахувати ймовірність того, що він стане 
наступним королем.
		
Дизайн:
Головна сторінка повинна мати заголовок "Лід і Вогонь: Хто 
стане наступним королем Семи Королівств?" та список героїв 
з "Гри престолів".
Користувач повинен мати можливість вибрати персонажа, 
натиснувши на його зображення або ім'я.
Після вибору персонажа користувач повинен побачити його 
характеристики та формулу для розрахунку ймовірності того, 
що він стане наступним королем.
Користувач повинен мати можливість ввести значення 
характеристик персонажа та отримати розрахункову ймовірність.

Робота з API:
Вам потрібно використовувати відкрите API, яке містить 
інформацію про характеристики героїв "Гри престолів". Ви 
можете використовувати будь-яке відкрите API за вашим 
розсудом, наприклад:
• https://thronesapi.com/
• https://anapioficeandfire.com/
• https://rapidapi.com/mrmalinsky08-MHGsijNPHM/api/game-
of-thrones1/


JS логіка (функціональність):
Для розрахунку ймовірності того, що герой стане наступним 
королем, вам потрібно використовувати формулу, яка враховує 
його характеристики. Формула повинна базуватися на логіці 
"Гри престолів" та вашому уявленні.
Необхідно створити функцію розрахунку ймовірності на основі 
введених користувачем значень характеристик героя.
Результат повинен бути виведений на екран у вигляді числа 
від 0 до 100 з вказівкою відсотка ймовірності.
Інтерактивність:
Додайте до інтерфейсу додатку елементи дизайну, які 
відображають тему "Лід і Вогонь", наприклад, фон у вигляді 
дракона або герба одного з домів.
Додайте короткий опис кожного героя.
Додайте анімації, які відображають дух "Гри престолів", 
наприклад, вибух вогню при виборі героя Дейенеріс або 
повільно падаючі сніжинки при виборі Джона Сноу.
Додайте елементи інтерактивності, наприклад, можливість 
змінювати фон або тему додатку в залежності від вибраного 
героя.
Короткі описи героїв повинні відображати їх значимість та 
особливості, наприклад, у Джона Сноу може бути опис 
"Незаконний син Старка, захисник Півночі, улюблений Денеріс 
Таргарієн". (це можна взяти, наприклад, з 
https://anapioficeandfire.com/ в розділі псевдоніми (aliases))
Додайте музичний супровід, який буде відповідати духу 
"Гри престолів", наприклад, тему "Джона Сноу" або 
"Дейенеріс Таргарієн".

Технічні вимоги:
Використовуйте HTML, CSS та JavaScript (ReactJs, Vue, Angular) 
для розробки сторінки.
Використовуйте безкоштовний API для отримання даних про 
персонажів, локації та епізоди.
Використовуйте Git для контролю версій.

Максимально використовуйте креатив. Посадіть свого короля на 
залізний трон!
Доля Семи Королівств у ваших руках!

Успіхів у розробці!`,
		work: `
Провели дві загальні конференції - познайомилися 
та коротко пройшлися по тому хто що знає і хто що вивчав
(у професійному плані). Обговорили апішки, склали схему,
як загалом виглядатиме наш проект; з розподілу роботи -
поки що плануємо хто і за що відповідатиме.

17.05.2023
1.готова головна сторінка з функціоналом;
2.Розбираємось з API;
3.Працюємо над версткою;

23.05.2023
рухаємось в хорошому темпі.
Основні труднощі виникають з оформленням - 
багато шукаємо та вигадуємо!)`,
		// video: './img/kingshand.png',
		video: 'https://www.youtube.com/embed/c3CumZlEAHI',
		linkCode: 'https://github.com/d1nosaurrr/GoT_team1',
		linkLivePage: ' https://d1nosaurrr.github.io/GoT_team1/',
		taemList:
			[
				{
					id: 1,
					avatarImg: `img/event2/vlad.png`,
					name: `Vlad Virchenko`,
					profession: `Trainee FrontEnd Developer`,
					summary: `https://innekto.github.io/Vladislav_Virchenko_Front-End-Developer/`,
					linkedIn: `https://www.linkedin.com/in/vlad-virchenko/`,
					git: `https://github.com/innekto`,
				},
				{
					id: 2,
					avatarImg: "",
					name: "Olena Kupko",
					profession: "",
					summary: "",
					linkedIn: "https://www.linkedin.com/in/elena-sloth-71682821a/",
					git: "https://github.com/ElenaSloth10",


				},
				{
					id: 3,
					avatarImg: "img/event2/Mykyta.jpg",
					name: "Mykyta Bykov",
					profession: "Frontend Developer",
					summary: "https://bit.ly/42PuaKj",
					linkedIn: "https://www.linkedin.com/in/mykyta-bykov-3857571ba",
					git: "https://github.com/d1nosaurrr",


				}
			]
	},
	// команда 4
	{
		id: 4,
		titleTeam: 'AegisGroup',
		description: `Назва проекту: "Авантюра з Ріком і Морті"

Опис завдання:
Вам потрібно розробити інтерактивну сторінку, 
на якій користувачі можуть вирушити у авантюру з Ріком і Морті.

Верстка (дизайн):
Використовуйте колірну палітру з мультсеріалу 
"Рік і Морті".
Використовуйте шрифти, які нагадують шрифти з титрів 
мультсеріалу.
Розробіть інтерфейс, який нагадує екран телепортації, як 
в серіалі.

Робота з API:
Додаток повинен використовувати безкоштовне API, щоб 
отримувати дані про персонажів, локації та епізоди з 
мультсеріалу "Рік і Морті". Наприклад - 
(https://rickandmortyapi.com/)

JS логіка (функціональність):
Розробіть функцію, яка генерує випадкового персонажа та 
відображає інформацію про нього на сторінці. Користувачі 
повинні мати можливість оновлювати інформацію, щоб отримати 
нового персонажа.
Розробіть функцію, яка генерує випадкову локацію з мультсеріалу 
та відображає інформацію про неї на сторінці.
Розробіть функцію, яка генерує випадковий епізод з мультсеріалу 
та відображає інформацію про нього на сторінці.
Розробіть функцію, яка рахує, скільки персонажів, локацій та 
епізодів було отримано користувачем.
Розробіть функціональність, яка дозволяє користувачу додавати 
персонажів, локації та епізоди в обране.
Кнопка «Телепортуватися». При натисканні на неї повинна 
відбуватися зміна локації та персонажів.

Інтерактивність:
При натисканні на кнопку "Телепортуватися", на екрані повинні 
з'являтися анімовані кільця, як у мультсеріалі, та звук 
телепортації.
При наведенні на елементи сторінки, повинні відбуватися зміни 
кольору або анімації, наприклад, при наведенні на кнопку 
"Додати до обраного", кнопка повинна починати блимати.
Розробіть функціональність, яка змінює кольори або розміри 
елементів сторінки при взаємодії користувача. 
(симуляція подорожі між світами)

Технічні вимоги:
Використовуйте HTML, CSS та JavaScript (ReactJs, Vue, Angular) 
для розробки сторінки.
Використовуйте безкоштовний API для отримання даних про 
персонажів, локації та епізоди.
Використовуйте Git для контролю версій.

Максимально використовуйте креатив. Змінюйте всесвіт 
Ріка і Морті за своїм бажанням!

Успіхів у розробці!`,
		work: `
17.05.2023
1.Провели декілька зустрічей, та познайомилися
2.Розподілили обов'язки
3.Налагодили командну роботу, та використовували notion, для 
відслідковування виконаних завдань учасниками команди
4.Почали виконувати завдання
5.Створили репозиторій, та налаштували його для командної роботи
6.Почалась розробка
7.To be continue...

23.05.2023
Команда #5 Звіт:
* Розробили логіку та відображення локацій, епізодів, та 
персонажів
* Почали розробку головної сторінки
* Налаштували збереження інформації в local storage:
   - зміна теми
   - кількість дій які здійснив користувач
   - улюблені персонажі/локації/епізоди
* Зробили code review`,
		// video: './img/cardImage/screamintothevoid.com_.png',
		video: 'https://www.youtube.com/embed/V7sQPT0eTQM',
		linkCode: 'https://github.com/vynnykpff/rick-and-morty-app',
		linkLivePage: 'https://vynnykpff.github.io/rick-and-morty-app/',
		taemList:
			[{
				id: 1,
				avatarImg: "https://cdn.discordapp.com/attachments/1106482400260792320/1106484927547052092/image.png",
				name: "Anton Vynnyk",
				profession: "Frontend developer",
				summary: "https://drive.google.com/file/d/1fU5OuJ-58rMlVvU_9uXrg6DR5KKeJGgv/view?usp=share_link",
				linkedIn: "https://www.linkedin.com/in/vynnykpff/",
				git: "https://github.com/vynnykpff",
			},
			{
				id: 2,
				avatarImg: "/img/event2/Hanna.jpg",
				name: "Hanna Taseniuk",
				profession: "Senior client verivication agent",
				summary: "https://docs.google.com/document/d/1ot--XJVeLklR3M98c0GKFBTrRgrbacUz/edit         ",
				linkedIn: "https://www.linkedin.com/in/hanna-taseniuk-b04766172/",
				git: "",

			},
			{
				id: 3,
				avatarImg: "img/event2/Tanya.jpeg",
				name: "Tetiana",
				profession: "Junior Front-end Developer",
				summary: "https://drive.google.com/file/d/1GdLd1qy3e6sIK__2htflTXS6bE8C0Pty/view",
				linkedIn: "https://www.linkedin.com/in/tetiana-tsar",
				git: "https://github.com/tumanchyk",

			}
			]
	},
	// команда 5
	{
		id: 5,
		titleTeam: 'Dev Doodles',
		description: `Тема завдання: "Калькулятор сили месників"
Опис: 
У даному завданні учасникам належить розробити веб-додаток
-калькулятор, який дозволить користувачеві обчислювати силу 
команди Месників, ґрунтуючись на їх характеристиках та певних 
формулах. Ідея полягає в тому, щоб надати користувачеві 
можливість "зібрати" свою команду з персонажів Марвел і 
дізнатися, наскільки сильна буде їхня команда у битві з 
іншими командами. 

Технічні вимоги: 
Використання будь-якого фреймворку для фронтенду 
(React, Angular, Vue.js, etc.). Дизайн та верстка мають бути 
оригінальними та відповідати темі Марвел. Робота з API 
безкоштовного джерела, який надає інформацію про персонажів 
Marvel (наприклад, Marvel API). Як js логіки запропонувати 
користувачеві вибір своєї команди та обчислити загальну силу 
команди на основі характеристик кожного персонажа. 

Пункти завдання:
Створити головну сторінку програми з інформацією про завдання 
та можливість переходу на сторінку калькулятора.
Створити сторінку калькулятора, де користувач зможе обирати 
персонажів Марвел із запропонованого списку.
Для кожного персонажа потрібно виводити інформацію про його 
характеристики (наприклад, ім'я, зростання, вага, суперздатність
 і т.д.) і можливість додати його до команди. 
Створити список вибраних персонажів, який відображатиметься на 
екрані користувача. Реалізувати логіку обчислення сили команди 
з урахуванням характеристик обраних персонажів Марвел. Для цього 
можна використовувати запропоновані формули з огляду на 
особливості кожного персонажа та його суперздатності.
Надати користувачеві можливість зберегти свою команду та 
поділитись нею в соціальних мережах. 
Створити сторінку з інформацією про команду Месників, надавши 
додаткову інформацію про персонажів, їх суперздатності та історію 
Месників. 

Примітка: 
Додайте анімації та інтерактивні елементи.
`,
		work: `
17.05.2023
1.Створили проєкт на Гітхабі та налаштували процес командної роботи;
2.Налаштували маршрутизацію;
3.Розробили власне апі з героями Марвел; 
4.Зробили базову версію сторінки опису;
5.Розробили компонент картки героя;
6.Розробили базові компоненти для обрання команд для змагань;
		
23.05.2023
1. Розробили дизайн WelcomePage
2. Розробили логіку калькуляції здібностей команд
3. В процесі 2 сторінки гри - обрання цілої команди та обрання 
по одному герою
4.  Розробляємо сторінку статистики`,
		// video: './img/cardImage/screamintothevoid.com_.png',
		video: 'https://www.youtube.com/embed/-QwZG2OTepY',
		linkCode: 'https://github.com/Iryna-Gry/itis-team-6',
		linkLivePage: 'https://iryna-gry.github.io/itis-team-6/',
		taemList:
			[{
				id: 1,
				avatarImg: "img/event2/irina.jpg",
				name: "Iryna Grytsaenko",
				profession: "Frontend developer (JavaScript, React)",
				summary: "https://drive.google.com/file/d/14lm_0NaIpnY3lSd9oumJWCNh9-g0qBqF/view?usp=share_link",
				linkedIn: "https://www.linkedin.com/in/iryna-grytsaenko/",
				git: "https://github.com/Iryna-Gry",
			},
			{
				id: 2,
				avatarImg: "img/event2/andr.jpeg",
				name: "Serhii Androsov",
				profession: "JavaScript Developer",
				summary: "https://andrsvsrg.github.io/Portfolio/",
				linkedIn: "https://www.linkedin.com/in/sergey-androsov-8b8964253/",
				git: "https://github.com/andrsvsrg",


			},
			{
				id: 3,
				avatarImg: "img/event2/Oleksandr.jpg",
				name: "Oleksandr Siryi",
				profession: "FrontEnd developer",
				summary: "https://drive.google.com/file/d/1xRpWQUjuEQnDVwOhLG51dwTcdJ56-9AD/view?usp=share_link",
				linkedIn: "https://www.linkedin.com/in/oleksandr-siryi/",
				git: "https://github.com/Siryi-Oleksandr",
			}
			]
	},

]


// ../../../public/img/cardImage